import type { Channel } from 'pusher-js';
import React, { createContext, useContext, useEffect, useState } from 'react';
import type { ReactNode } from 'react';

import { useSocketContext } from './Socket';

export type Context = Channel | null;

export const ChannelContext = createContext<Context>(null);

type Props = {
  channelName: string,
  children: ReactNode,
};

export const ChannelProvider = ({ channelName, children }: Props) => {
  const { pusher } = useSocketContext();
  const [channel, setChannel] = useState<Context>(null);

  useEffect(() => {
    if (pusher) {
      setChannel(pusher.subscribe(channelName));
    }

    return () => {
      if (pusher) {
        pusher.unsubscribe(channelName);
        pusher.disconnect();
      }
    };
  }, [pusher]);

  return <ChannelContext.Provider value={channel}>{children}</ChannelContext.Provider>;
};

export const useChannel = () => useContext(ChannelContext);
